"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredResultsWithColumnFilters = getFilteredResultsWithColumnFilters;

var _forIn = _interopRequireDefault(require("lodash/forIn"));

var _some = _interopRequireDefault(require("lodash/some"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function filterResult(result, keys, columnFilters) {
  return !(0, _some["default"])(keys, function (key) {
    return !columnFilters[key].filter(result[key]);
  });
}

function getFilteredResultsWithColumnFilters(results, columnFilters) {
  if (!results) {
    return [];
  }

  if (!columnFilters) {
    return results;
  }

  var keys = [];
  (0, _forIn["default"])(columnFilters, function (value, key) {
    return keys.push(key);
  });
  return results.filter(function (result) {
    return filterResult(result, keys, columnFilters);
  });
}